(() => {
  'use strict';
  const policy = {
    isGift: i => String(i.properties?._famli_free_gift || '') === 'true',
    subtotal(cart, config) {
      return (cart.items || []).reduce((sum, i) => sum + (!this.isGift(i) && !i.gift_card ? Number(i.final_line_price ?? i.line_price ?? 0) : 0), 0);
    },
    qualifies(cart, config) { return cart.currency === 'DKK' && this.subtotal(cart, config) >= config.threshold; },
    rewardProgress(cart, config) {
      const target = Math.max(Number(config.threshold), Number(config.shippingThreshold || 0));
      const subtotal = this.subtotal(cart, config);
      return {target, subtotal, remaining: Math.max(0, target - subtotal), percent: Math.min(100, Math.max(0, subtotal / target * 100)), unlocked: this.qualifies(cart, config) && subtotal >= target};
    },
    gifts(cart) { return (cart.items || []).filter(i => this.isGift(i)); },
    validGift(cart, config) {
      const gifts = this.gifts(cart);
      return this.qualifies(cart, config) && gifts.length === 1 && gifts[0].quantity === 1 && config.giftProducts.some(g => Number(g.variantId) === Number(gifts[0].variant_id)) && gifts[0].final_line_price === 0;
    },
    codes(cart, code, include) {
      const codes = (cart.discount_codes || []).map(d => d.code).filter(Boolean).filter(c => c.toUpperCase() !== code.toUpperCase());
      if (include && code) codes.push(code);
      return [...new Set(codes)].join(',');
    }
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = policy; return; }
  const node = document.getElementById('FamliFreeGiftConfig');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config.enabled || !config.giftProducts.length) return;
  const root = window.Shopify?.routes?.root || '/';
  const state = { cart:config.initialCart || null, busy:false, error:'', preview:null, changing:false, pending:false };
  let checkoutApproved=false;
  let publishing = false, refreshTimer;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = n => new Intl.NumberFormat('da-DK', {style:'currency',currency:'DKK',minimumFractionDigits:0,maximumFractionDigits:2}).format(n / 100);
  const copy = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', value), config.strings?.[key] || '');
  const sections = () => {
    const ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections:ids}}));
    const main = document.querySelector('main-cart');
    if (main) ids.push(main.id.replace('MainCart-',''));
    return [...new Set(ids.filter(Boolean))].slice(0,5);
  };
  async function request(path, payload) {
    const response = await fetch(root + path, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{method:'POST',body:JSON.stringify({...payload,sections:sections(),sections_url:location.pathname})}:{})});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Prøv igen om et øjeblik.');
    return result;
  }
  const fetchCart = () => request('cart.js');
  function publish(cart) {
    state.cart = cart; publishing = true;
    if (cart.sections && window.FoxTheme?.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart});
    publishing = false; render();
  }
  async function removeGifts(cart) {
    const updates = Object.fromEntries(policy.gifts(cart).map(g => [g.key,0]));
    const result = await request('cart/update.js',{updates,discount:policy.codes(cart,config.discountCode,false)});
    publish(result); return result;
  }
  function render() {
    if (!state.cart) return;
    const cart = state.cart, reward = policy.rewardProgress(cart, config), unlocked = reward.unlocked;
    const gift = policy.validGift(cart, config) ? policy.gifts(cart)[0] : null;
    const selected = unlocked ? gift?.variant_id || (!config.checkoutReady && state.preview) : null;
    const selectedProduct = config.giftProducts.find(g => Number(g.variantId) === Number(selected));
    const available = config.giftProducts.some(g => g.available);
    const message = cart.currency !== 'DKK' ? copy('currency') : unlocked ? copy('reached') : copy('remaining', {amount: '<b>' + money(reward.remaining) + '</b>'});
    const selection = selectedProduct ? copy('selected', {title: esc(selectedProduct.title)}) : '';
    const delivery = selectedProduct?.preorder ? `<p class="famli-free-gift__delivery">${esc(copy('delivery'))}</p>` : ''; 
    const cards = config.giftProducts.map(g => {
      const isSelected = Number(selected) === Number(g.variantId);
      const label = !g.available ? copy('sold_out') : isSelected ? copy('chosen') : unlocked ? copy('choose_option') : copy('locked_option');
      return `<div class="famli-free-gift__card"><button type="button" class="famli-free-gift__option${isSelected ? ' is-selected' : ''}" data-famli-gift-variant="${g.variantId}" aria-pressed="${isSelected}" ${!unlocked || !g.available || state.busy ? 'disabled' : ''}><img src="${esc(g.image)}" alt="" width="120" height="100" loading="lazy"><strong>${esc(g.title)}</strong>${g.preorder ? `<small class="famli-free-gift__preorder">${esc(copy('preorder'))}</small><small class="famli-free-gift__week">Uge 48</small>` : ''}<span class="famli-free-gift__action">${esc(label)}</span></button><a class="famli-free-gift__product-link" href="${esc(g.url)}" aria-label="Se produktet: ${esc(g.title)}">Se produktet</a></div>`;
    }).join('');
    const html = `<section class="famli-free-gift${unlocked ? ' is-unlocked' : ''}" aria-label="${esc(copy('heading'))}" aria-busy="${state.busy}"><div class="famli-free-gift__goal"><div class="famli-free-gift__heading"><strong>${esc(copy('heading'))}</strong><span>${esc(money(reward.target))}</span></div><p aria-live="polite">${message}</p><div class="famli-free-gift__progress" role="progressbar" aria-label="${esc(copy('heading'))}" aria-valuenow="${Math.round(reward.percent)}" aria-valuemin="0" aria-valuemax="100"><span style="width:${reward.percent}%"></span></div></div><div class="famli-free-gift__selection" aria-live="polite">${selection ? `<p>${selection}</p>` : ''}${delivery}${!available ? '<p>' + esc(copy('all_sold_out')) + '</p>' : ''}${state.busy ? '<p class="famli-free-gift__status">' + esc(copy('updating')) + '</p>' : ''}</div><div class="famli-free-gift__grid">${cards}</div>${state.error ? '<p role="alert" class="famli-free-gift__error">' + esc(state.error) + '</p>' : ''}</section>`;
    document.querySelectorAll('[data-famli-gift-mount]').forEach(el => { if (el.innerHTML !== html) el.innerHTML = html; });
  }
  async function refresh() {
    if(state.busy){schedule();return;} state.busy=true;state.pending=false;
    try {
      const cart=await fetchCart();state.cart=cart;
      if(config.checkoutReady&&policy.gifts(cart).length&&!policy.validGift(cart,config)) {
        await removeGifts(cart);
        state.error=policy.qualifies(cart,config)?'Vælg din gave igen. Den bliver kun lagt i kurven, hvis prisen er 0 kr.':'';
      }
      if(!policy.qualifies(state.cart,config)){state.preview=null;state.changing=false;}
    } catch(_){state.error='Vi kunne ikke opdatere gavevalget. Prøv igen.';}
    finally{state.busy=false;render();}
  }
  function schedule(){state.pending=true;clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,250);}
  async function choose(id) {
    if(state.busy)return;
    const product=config.giftProducts.find(g=>Number(g.variantId)===Number(id));
    if(!product?.available || !state.cart || !policy.rewardProgress(state.cart,config).unlocked)return;
    if(!config.checkoutReady){state.preview=Number(id);state.changing=false;render();return;}
    state.busy=true;state.error='';render();
    let before;
    try {
      let cart=await fetchCart();before=cart;
      if(!policy.qualifies(cart,config)){state.cart=cart;throw new Error('Kurven er under beløbsgrænsen. Tilføj lidt mere for at vælge en gave.');}
      if(policy.gifts(cart).length)cart=await removeGifts(cart);
      await request('cart/add.js',{items:[{id:Number(id),quantity:1,properties:{_famli_free_gift:'true',...(product.preorder ? {Forudbestilling:'Ja',Levering:copy('delivery')} : {})}}]});
      cart=await request('cart/update.js',{discount:policy.codes(cart,config.discountCode,true)});
      if(!policy.validGift(cart,config))throw new Error('Gaven kunne ikke kombineres med den nuværende kurv eller rabat. Den er fjernet, så du ikke betaler for den.');
      if(cart.total_price>before.total_price)throw new Error('Din nuværende rabat giver dig en bedre pris. Vi beholder den og fjerner gaven.');
      publish(cart);state.changing=false;
    } catch(error) {
      try {const cart=await fetchCart();if(policy.gifts(cart).length)await removeGifts(cart);} catch(_){state.error='Gaven kunne ikke bekræftes. Opdatér kurven før du går videre.';}
      state.error=state.error||error.message;
    } finally{state.busy=false;render();}
  }
  document.addEventListener('click',event=>{
    const option=event.target.closest('[data-famli-gift-variant]');
    if(option){event.preventDefault();choose(option.dataset.famliGiftVariant);return;}
    if(event.target.closest('[data-famli-gift-change]')){state.changing=true;render();}
  });
  async function verifyCheckout(resume) {
    if(state.busy){state.error='Vi opdaterer kurven. Prøv igen om et øjeblik.';render();return;}
    state.busy=true;state.error='';clearTimeout(refreshTimer);render();
    try {
      const cart=await fetchCart();state.cart=cart;
      if(policy.gifts(cart).length&&!policy.validGift(cart,config)){
        await removeGifts(cart);
        state.error='Din gave er fjernet, fordi kurven eller rabatten er ændret. Kontrollér kurven, og fortsæt derefter.';
        return;
      }
      checkoutApproved=true;resume();
    } catch(_){state.error='Vi kunne ikke kontrollere kurven. Prøv igen om et øjeblik.';}
    finally{state.busy=false;state.pending=false;render();checkoutApproved=false;}
  }
  document.addEventListener('click',event=>{
    const checkout=event.target.closest('[name="checkout"],a[href^="/checkout"]');
    if(!checkout||!config.checkoutReady||checkoutApproved)return;
    event.preventDefault();event.stopImmediatePropagation();
    verifyCheckout(()=>{
      if(checkout.tagName==='A')location.assign(checkout.href);
      else if(checkout.form)checkout.form.requestSubmit(checkout);
    });
  },true);
  document.addEventListener('submit',event=>{
    if(!config.checkoutReady||checkoutApproved||event.submitter?.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();
    const form=event.target,submitter=event.submitter;
    verifyCheckout(()=>form.requestSubmit(submitter));
  },true);
  const init=()=>{
    if(window.FoxTheme?.pubsub)FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,()=>{if(!publishing)schedule();});
    ['cart:updated','cart:update','cart:refresh','product-ajax:added','shopify:section:load'].forEach(name=>document.addEventListener(name,schedule));
    new MutationObserver(()=>{if([...document.querySelectorAll('[data-famli-gift-mount]')].some(el=>!el.firstElementChild))render();}).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});render();refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();




